import Icon from '@components/v2/ui/Icon/Icon';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { ExternalLink, FileText } from 'lucide-react';
import { DownloadBlock as DownloadBlockType } from '../../viz.types';

interface DownloadBlockProps {
  block: DownloadBlockType;
}

const DownloadBlock = ({ block }: DownloadBlockProps) => {
  return (
    <Box
      component="a"
      href={block.url}
      target="_blank"
      rel="noopener noreferrer"
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        p: 1,
        border: 1,
        borderRadius: theme.shape.borderRadiusXs,
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        textDecoration: 'none',
        color: 'text.primary',
        cursor: 'pointer',
      })}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 40,
          height: 40,
        }}
      >
        <Icon icon={FileText} size="lg" />
      </Box>

      <Stack sx={{ minWidth: 0, flex: 1 }}>
        <Typography variant="subtitle2" noWrap>
          {block.title}
        </Typography>
        <Typography variant="caption" color="text.secondary" noWrap>
          {block.fileName}
        </Typography>
      </Stack>

      <Box sx={{ display: 'flex', flexShrink: 0, color: 'text.secondary' }}>
        <Icon icon={ExternalLink} size="md" />
      </Box>
    </Box>
  );
};

export default DownloadBlock;
